import React from 'react';
import {connect} from 'react-redux';
import DrawerActions from './DrawerActions';
// import Can from "../../utils/roles";

const DrawerBtn = (props) =>{
    // function mouseEnter(){
    //     // if(width>768){
    //     //     openCloseDrawer(props)
    //     // }else{
            
    //     // }
    //     props.openDrawer()
    // }
    // function mouseLeave(){
    //     if(props.isDrawerPin){
            
    //     }else{
    //         props.closeDrawer()
    //     }
    // }
    function handleDrawer(){
        if(props.isDrawerOpen && props.isDrawerPin){
            props.closeDrawer()
        }else if(props.isDrawerOpen && !props.isDrawerPin){
            props.openDrawer()
        }
        else{
            props.openDrawer()
        }
        props.toggleDrawerPin()
        props.toggleDrawerFix() 
    }
    return(
        <i 
            className={`fa  ${props.icon? 'fa-'+props.icon : 'fa-bars'} drawerBtn ${props.isDrawerOpen? 'active': ''}`} 
            aria-hidden="true"
            onClick={()=>handleDrawer()} 
            // onMouseEnter={() => mouseEnter()}
            // onMouseLeave={() => mouseLeave()}
        ></i>
    )
}

const mapStateToProps = state =>{
    return{
        isDrawerOpen: state.handleDrawer.isDrawerOpen,
        isDrawerFix: state.handleDrawer.isDrawerFix,
        isDrawerPin: state.handleDrawer.isDrawerPin
    }
}
export default connect(mapStateToProps, DrawerActions)(DrawerBtn);

